import { Component, ViewChild } from '@angular/core';
import { NavController, Platform } from 'ionic-angular';

import { ApiTearSheetPage } from '../pages/api-tear-sheet/api-tear-sheet';
import { FileUploadPage } from '../pages/file-upload/file-upload';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { UserManagementPage } from '../pages/user-management/user-management';
import { CompliancePage } from '../pages/compliance/compliance';

import { AccountProvider } from '../providers/account/account';
import { AwsProvider } from '../providers/aws/aws';
import { UsersProvider } from '../providers/users/users';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  //<ion-nav> is referred to by #content here
  @ViewChild('content') nav: NavController;

  public rootPage: any;
  public awsAccount: string;

  pages: Array<{title: string, component: any}>;

  constructor(public platform: Platform, public aws: AwsProvider, public usersPro: UsersProvider, public accountPro: AccountProvider) {
    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'Home', component: HomePage },
      { title: 'Client File Uploads', component: FileUploadPage },
      { title: 'User Management', component: UserManagementPage },
      { title: 'API Tear Sheets', component: ApiTearSheetPage },
      { title: 'Compliance', component: CompliancePage }
    ];
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {

      // Determine if we're on live or dev
      if(this.aws.isLive()){
        this.awsAccount = "LIVE";
      }else{
        this.awsAccount = "DEV";
      }
      // The platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.aws.userLoggedIn().then((result) => {
        if (!result) {
          this.rootPage = LoginPage;
        } else {
          this.rootPage = HomePage;
        }
      });
    });
  }

  openPage(page) {
    this.nav.setRoot(page.component);
  }

  logOut() {
    this.aws.signOut().then(() => {
      this.nav.setRoot(LoginPage);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts